import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  color,
  font,
  layer,
  media,
  motion,
  radius,
  size,
  space,
} from "../../styles/theme";

export const FooterSection = styled("footer")`
  position: relative;
  /* Without this the fixed atmosphere layer (z-index 1) paints its vignette
     over the footer, muddying the corners. */
  z-index: ${layer.content};
  background: ${color.abyss};
  border-top: 1px solid ${color.ash};
  padding: clamp(3rem, 7vw, 5rem) 0 ${space.xl};
`;

export const Grid = styled("div")`
  display: grid;
  grid-template-columns: 1.6fr repeat(3, 1fr);
  gap: clamp(2rem, 5vw, 3.5rem);
  padding-bottom: ${space.xxl};

  ${media.lg} {
    grid-template-columns: 1fr 1fr;
  }

  ${media.sm} {
    grid-template-columns: 1fr;
    gap: ${space.xl};
  }
`;

export const BrandBlock = styled("div")`
  max-width: 34ch;
`;

export const BrandRow = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  color: ${color.pale};
  margin-bottom: ${space.md};

  &:hover {
    color: ${color.pale};
  }

  img {
    opacity: 0.75;
    transition: opacity ${motion.base} ${motion.easeOut};
  }

  &:hover img {
    opacity: 1;
  }
`;

export const Blurb = styled("p")`
  font-size: ${size.small};
  color: ${color.smoke};
  margin: 0 0 ${space.lg};
`;

export const ColumnTitle = styled("h2")`
  font-family: ${font.label};
  font-size: ${size.micro};
  font-weight: 400;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: ${color.smoke};
  margin: 0 0 ${space.md};
`;

export const LinkList = styled("ul")`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 0.65rem;
`;

const linkStyles = `
  font-size: 0.9375rem;
  color: ${color.bone};
  background: none;
  border: 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
  transition: color ${motion.fast} ${motion.easeOut};

  &:hover {
    color: ${color.ember};
  }
`;

export const FooterLink = styled(Link)`
  ${linkStyles}
`;

export const FooterAnchor = styled("a")`
  ${linkStyles}
`;

export const FooterButton = styled("button")`
  ${linkStyles}
  font-family: inherit;
`;

export const Bottom = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${space.lg};
  padding-top: ${space.lg};
  border-top: 1px solid ${color.ash};
`;

export const Copyright = styled("p")`
  margin: 0;
  font-family: ${font.label};
  font-size: ${size.micro};
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${color.smoke};
`;

export const StoreBadges = styled("div")`
  display: flex;
  align-items: center;
  gap: ${space.md};

  a {
    display: inline-flex;
    filter: grayscale(1) brightness(0.8);
    transition: filter ${motion.base} ${motion.easeOut},
      transform ${motion.base} ${motion.ease};
  }

  ${media.hover} {
    a:hover {
      filter: none;
      transform: translateY(-2px);
    }
  }

  img {
    height: 40px;
    width: auto;
  }
`;

export const Social = styled("div")`
  display: flex;
  gap: ${space.xs};

  a {
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    border: 1px solid ${color.ash};
    border-radius: ${radius.md};
    color: ${color.smoke};
    transition: all ${motion.fast} ${motion.easeOut};
  }

  a:hover {
    color: ${color.white};
    border-color: ${color.bloodBright};
    background: ${color.bloodFaint};
  }

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
`;
